// ported over from EXT:sab2018 [sic]
(function($) {
  document.addEventListener('sab2019:initialized', () => {
    // make sure that the menu was initialized by listening to the event triggered by the main.js of EXT:sab2016
    const menu = $("#sidemenu").data("mmenu");

    if (menu) {
      document.querySelector('.navbar-toggler').addEventListener('click', function() {
        menu.open();
      })
    }
  });
})(jQuery);
